import {InitPage} from "../../index";
import { ImportFile } from "../../common/import_file";
import swal from "sweetalert";

class Picking extends ImportFile {
    constructor() {
        super();
        let _this = this;

        $('#csv_import_dialog').click((e) => {
            e.preventDefault();
            $('#import-dialog').modal({ backdrop: 'static', keyboard: false });

            $('#modal-title').text('Import Pick List');
            $('input[name="id"]').val('');
            $('input[name="title"]').val('');
            $('input[name="so_number"]').val('');
            $('textarea[name="note"]').val('');
            $('input[name="template_file"]').val('');
            $('input[name="template_file"]').prop('required', true);
            $("label[for='template_file']").prop('class', 'required');

            $('#importing_error').hide();
            $('#file-import').show();
            $('#button-import').text('Save & Import');
        });


        $('.csv_export_dialog').click(function(e) {
            e.preventDefault();
            const href = this.getAttribute('data-href');
            $('#item-level').attr('href', `${href}?export_type=items`)
            $('#tag-level').attr('href', `${href}?export_type=tags`)
            $('#export-dialog').modal({ backdrop: 'static', keyboard: false });
        });

        $("#upload_file_picking_form").submit((e) => {
            e.preventDefault();

            if($(".import_loading").is(':visible'))
                return;

            $('#importing_error').hide();
            _this.updateLoadingStatus(true);
            ($("#upload_file_picking_form") as any).ajaxSubmit({
                url: $(this).attr("action"),
                type: "post",
                dataType: "JSON",
                success: (data, _, xhr) => {
                    _this.updateLoadingStatus(false);
                    if (xhr.status === 204) { // No Content
                        $("#submitUpload").hide();
                        $("#btn-close-modal").hide();
                        $("#finished_stats").show();
                        $("#proceedToPrinting").show();
                        $("#finished_stats").html(`<i class="fa fa-check text-success"></i> Updated successfully`);
                        $("#proceedToPrinting").on("click", function(){
                            window.location.reload();
                        });
                        return;
                    }

                    $("#submitUpload").hide();
                    $("#proceedToPrinting").show();
                    $("#btn-close-modal").hide();
                    $("#finished_stats").html(`<i class="fa fa-check text-success"></i> ${data.message}`);
                    $("#finished_stats").show();
                    $("#proceedToPrinting").on("click", function(){
                        window.location.reload();
                    })
                },
                error: ({responseJSON}) => {
                    _this.updateLoadingStatus(false);
                    $("#importing_error").text(responseJSON.errors);
                    $("#importing_error").show();
                }
            });
        });

        $(".accordion-arrow-icon").on("click", (e) => {
            if (e.target.classList.contains("fa-chevron-down")) {
                e.target.parentElement.setAttribute("data-remote", "true");
                e.target.classList.remove("fa-chevron-down");
                e.target.classList.add("fa-chevron-up");
            } else {
                e.preventDefault();
                e.target.parentElement.removeAttribute("data-remote");
                e.target.classList.add("fa-chevron-down");
                e.target.classList.remove("fa-chevron-up");
            }
        });

        $(".delete-picking").on("click", function(e) {
            swal({
                title: 'Are you sure?',
                text:  'Note: This operation will delete the picking!',
                icon: "warning",
                closeOnClickOutside: false,
                buttons: {
                    cancel: { text: "No", value: null, visible: true, className: "sn-btn sn-btn-sm sn-btn-silver", closeModal: true },
                    confirm: { text: "Yes", value: true, visible: true, className: "sn-btn sn-btn-sm sn-btn-red", closeModal: true }
                },
                dangerMode: true,
            }).then((willDelete) => {
                if (!willDelete) { return false; }

                $("#pin-auth-dialog #redirect_url").val($(e.currentTarget).next().attr('href'));
                $('#pin-auth-dialog').modal('show');
            });
        });
    }
}

export function LoadPage() {
    InitPage("pickings", () => new Picking());
}
